/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import Portal from 'components/base/Portal';
import Button from 'components/base/Button';
import Icon from 'components/icon';
import forms from './forms';
import { Download } from 'lucide-react';
console.log('🚀 ~ forms:', forms);

const PrintFormButton = ({ formType, data, buttonProps }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePrint = () => {
    setIsOpen(true);
    setTimeout(() => {
      setIsPrinting(true);
    }, 300);
  };

  return (
    <>
      <Button
        // onClick={() => setIsPrinting(true)}
        onClick={handlePrint}
        variant={`primary`}
        className=""
        {...buttonProps}
      >
        <Download size={16} />
        Download
      </Button>
      {/* {loading && (
        <Portal>
          <PageLoader loading={loading} loadingMessage={'Printing challan'} />
        </Portal>
      )} */}

      {isOpen && !loading && (
        <FormPrint
          formType={formType}
          print={isPrinting}
          data={data}
          onComplete={() => {
            setIsOpen(false);
            setIsPrinting(false);
          }}
        />
      )}
    </>
  );
};

const FormPrint = ({ formType, data, print, onComplete }) => {
  console.log('🚀 ~ formType:', formType);
  useEffect(() => {
    if (print) {
      const input = document.getElementById('form');

      var toPrint = input;
      var popupWin = window.open('', '_blank');
      if (popupWin?.document) {
        popupWin.document.open();
        popupWin.document.write(
          '<html style="visibility: hidden;  margin-top:0px;padding-top:0px;"><head><style> @page { size: 210mm 297mm;  margin:0; padding: 0; } @media print {@page { size: 210mm 297mm;   }  </style></head><body onload="window.print()" style="visibility: visible;">'
        );

        popupWin.document.write(toPrint.innerHTML);
        popupWin.document.write('</html>');
        popupWin.document.close();
        popupWin.onload = () => {
          popupWin.print({
            header: false,
            footer: false
          });
          popupWin.close();
        };
      }
      onComplete();
    }
  }, [print]);
  return (
    <Portal>
      <div
        className="overflow-hidden"
        style={{ zIndex: '-1', position: 'fixed', top: '0', left: '-100vw' }}
      >
        <div
          id="form"
          className="position-relative"
          style={{
            maxWidth: '8.27in',
            //   maxHeight: '8.27in',
            minWidth: '8.27in',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: '35px',
            boxShadow: '0px 0px 6px #ccc'
          }}
        >
          {forms[formType]({ data })}
        </div>
      </div>
    </Portal>
  );
};

export { PrintFormButton };
